import React from 'react'
import { Text } from '../../../../styles/reactnative'
import SettingChange from './SettingChange'
import { Space } from 'antd'

export const columns = (mutate, usermodal) => {
	return [
		{
			title: '내용',
			dataIndex: 'desc',
			key: 'desc',
			width: 330,
			render: (text, record) => (
				<Space.Compact
					style={{
						textAlign: 'left',
						alignItems: 'flex-start',
						justifyContent: 'flex-start',
						alignContent: 'flex-start',
					}}>
					<Text
						style={{
							textAlign: 'left',
							background: record?.id?.substr(0, 1) == 'C' ? '#45f' : '#f50',
							color: 'white',
							minWidth: 50,
							marginRight: 5,
						}}>
						{record?.id?.substr(0, 1) == 'C' ? '코인' : '글로벌'}
					</Text>
					<Text
						style={{
							textAlign: 'left',
							background: '#444',
							color: 'white',
							minWidth: 50,
							marginRight: 5,
						}}>
						{text?.split(':')[0]}
					</Text>
					<Text style={{ textAlign: 'left' }}>
						{text?.substr(text?.indexOf(':') + 1)}
					</Text>
				</Space.Compact>
			),
		},
		{
			title: '설정값',
			dataIndex: 'setting',
			key: 'setting',
			align: 'left',
			render: (text, record) => (
				<SettingChange data={record} mutate={mutate} />
			),
		},
		{
			title: '키(개발자용)',
			dataIndex: 'id',
			key: 'id',
			width: 100,
			align: 'center',
			render: (text, record) => (
				<Text>
					{text} ({record?.pubkey})
				</Text>
			),
		},
	]
}
